import React, { ReactElement } from 'react';
import { View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import KitCopyrightLogo from '../components/KitCopyrightLogo';
import RecaptchaDisclaimer from '../components/RecaptchaDisclaimer';
import Spacing from '../theming/Spacing';

interface AuthFooterProps {
  showFooter?: boolean;
  showRecaptcha?: boolean;
  suppressSubsplashBranding?: boolean;
}

export default function AuthFooter({
  showFooter,
  showRecaptcha,
  suppressSubsplashBranding,
}: AuthFooterProps): ReactElement | null {
  const insets = useSafeAreaInsets();

  if (!showFooter || (suppressSubsplashBranding && !showRecaptcha)) {
    return null;
  }

  return (
    <View style={{ alignItems: 'center', marginTop: Spacing.xxxxl }}>
      {!suppressSubsplashBranding ? (
        <KitCopyrightLogo
          viewStyle={{
            marginBottom: showRecaptcha
              ? Spacing.m
              : insets.bottom + Spacing.xl,
          }}
        />
      ) : null}
      {showRecaptcha ? (
        <View style={{ marginBottom: insets.bottom }}>
          <RecaptchaDisclaimer />
        </View>
      ) : null}
    </View>
  );
}
